export default "__VITE_ASSET__72ecaa3e__"